import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ImageLightbox from './ImageLightbox';

const NewsCard = ({ news, image }) => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const getImageUrl = (imgPath) => {
    if (!imgPath) return null;
    if (imgPath.startsWith('http://') || imgPath.startsWith('https://')) return imgPath;
    // Относительный путь (уже начинается с /uploads/)
    return imgPath;
  };

  const handleImageClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setLightboxIndex(0);
    setLightboxOpen(true);
  };

  const imageUrl = getImageUrl(image);
  const allImages = news.images ? news.images.map(getImageUrl) : [];

  return (
    <>
      <article className="news-card">
        <div className="news-img" onClick={handleImageClick} style={{ cursor: 'pointer' }}>
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={news.title}
              style={{ width: '100%', height: '200px', objectFit: 'cover', display: 'block' }}
            />
          ) : (
            <div style={{ width: '100%', height: '200px', backgroundColor: '#ddd', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#666' }}>
              Изображение отсутствует
            </div>
          )}
        </div>
        <div className="news-content">
          <div className="news-date">{news.date}</div>
          <h3 className="news-title">{news.title}</h3>
          <p className="news-excerpt">{news.excerpt}</p>
          <Link to={`/news/${news.id}`} className="btn" style={{ padding: '10px 20px', fontSize: '0.9rem' }}>
            Подробнее
          </Link>
        </div>
      </article>
      {lightboxOpen && (
        <ImageLightbox
          images={allImages.length ? allImages : [imageUrl]}
          currentIndex={lightboxIndex}
          onClose={() => setLightboxOpen(false)}
        />
      )}
    </>
  );
};

export default NewsCard;